import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom/client";
import { HashRouter, Routes, Route, BrowserRouter } from "react-router-dom";
import { initializeIcons, ActionButton, Stack } from "@fluentui/react";
import { Providers, ProviderState } from "@microsoft/mgt-element";
import fordLogo from "../src/assets/fordIcon.png";
import { Msal2Provider } from "@microsoft/mgt-msal2-provider";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
export { PopupModal };
import PopupModal from "./components/Popup";
import { useIdleTimer } from "react-idle-timer";

import logo from "./assets/Life@Ford.png";
import genieLogo from "./assets/genie.png";

import "./index.css";

import Layout from "./pages/layout/Layout";
import NoPage from "./pages/NoPage";
import OneShot from "./pages/oneshot/OneShot";
import Chat from "./pages/chat/Chat";
import { Person } from "@microsoft/mgt-react";
import { colors } from "@react-spring/shared";

import "./assets/fonts/FordMotion/woff/FordMotion-Regular.woff";
import "./assets/fonts/FordAntenna/Antenna-Regular.woff";
import "./assets/fonts/ArialNova/ArialNova.ttf";
import lockIcon from "./assets/lock.svg";
import rightArrow from "./assets/path.svg";
import rightArrowBlue from "./assets/pathBlue.svg";

const tenantId = "c990bb7a-51f4-439b-bd36-9c07fb1041c0";

//const redirectUri = "http://localhost:5173";
//const redirectUri = "http://localhost:5000";

//const redirectUri = "https://compgptprod.azurewebsites.net/";
//const redirectUri = "https://compgptqa.azurewebsites.net/";
//const redirectUri = "https://www.compgenieqa.ford.com/";
const redirectUri = "https://www.compgenie.ford.com/";
//const redirectUri = "https://compgpt-brc4fadraedsggga.eastus-01.azurewebsites.net/";
//const redirectUri = "https://compgptdev-a6cqh0a6gad2cygm.eastus-01.azurewebsites.net/";
//const redirectUri = "https://app-backend-iid7gnpe625be.azurewebsites.net/"
//const redirectUri = "https://hrrevchatbot.azurewebsites.net/";

const msalInstance = new Msal2Provider({
    //clientId: "36ab7d87-e480-43e7-a4fb-fb59a6c9589b",
    clientId: "ae5fc2ab-d8a9-4544-b282-23bf5d57bfed",
    loginType: 1,
    redirectUri: redirectUri,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    scopes: ["openid", "profile", "User.Read"]
});

Providers.globalProvider = msalInstance;

// We define handleLogout once, so it can be used everywhere.
const handleLogout = () => {
    sessionStorage.setItem("agreementFlag", "");
    sessionStorage.setItem("signout", "1");
    msalInstance.logout();
};

const gp = Providers.globalProvider;
function autoLogin() {
    if (!gp.login) return false;
    try {
        if (!gp.getActiveAccount) return false;
        const acc = gp.getActiveAccount();
        if (!acc) throw Error("noAccount");
    } catch (e) {
        gp.login();
    }
}
autoLogin();

function useIsSignedIn(): [boolean] {
    const [isSignedIn, setIsSignedIn] = useState(false);

    useEffect(() => {
        const updateState = () => {
            const provider = Providers.globalProvider;
            setIsSignedIn(provider && provider.state === ProviderState.SignedIn);
        };

        Providers.onProviderUpdated(updateState);
        updateState();
        return () => {
            Providers.removeProviderUpdatedListener(updateState);
        };
    }, []);

    return [isSignedIn];
}

initializeIcons();

export default function App() {
    const [isSignedIn] = useIsSignedIn();
    const [isOpen, setIsOpen] = useState(true);
    const [isIdle, setIsIdle] = useState(false);
    const logoutTimer = useRef<NodeJS.Timeout>();

    const onIdle = () => {
        if (isSignedIn && agreementFlag) {
            setIsIdle(true);
        }
    };

    // This effect handles the auto-logout after the idle prompt is shown
    useEffect(() => {
        if (isIdle) {
            // Set a 3-minute timer to automatically log out
            logoutTimer.current = setTimeout(() => {
                handleLogout();
            }, 3 * 60 * 1000); // 3 minutes
        }

        // Cleanup function to clear the timer if the component unmounts or isIdle changes
        return () => {
            if (logoutTimer.current) {
                clearTimeout(logoutTimer.current);
            }
        };
    }, [isIdle]);

    const { reset } = useIdleTimer({
        onIdle,
        timeout: 1000 * 60 * 15, // 15 minutes
        throttle: 500
    });

    const handleRefresh = () => {
        // Close the prompt immediately for better UX
        setIsIdle(false);
        if (logoutTimer.current) {
            clearTimeout(logoutTimer.current);
        }
        // This will reload the entire page from the server
        window.location.reload();
    };

    const handleManualLogout = () => {
        // Close the prompt immediately for better UX
        setIsIdle(false);
        if (logoutTimer.current) {
            clearTimeout(logoutTimer.current);
        }
        handleLogout();
    };

    const [headColor, setHeadColor] = useState(false);
    const [agreementFlag, setAgreementFlag] = useState(false);
    const [windowDimension, detectHW] = useState({
        winWidth: window.innerWidth,
        winHeight: window.innerHeight
    });
    const [isDropdownVisibleName, setDropdownVisibleName] = useState(false);

    const headerStyleNotSignedIn: React.CSSProperties = {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center"
    };

    const changeHeadColor = () => {
        if (window.scrollY >= 50) {
            setHeadColor(true);
        } else {
            setHeadColor(false);
        }
    };

    window.addEventListener("scroll", changeHeadColor);

    let ignore = false;
    useEffect(() => {
        if (!ignore) {
            if (sessionStorage.getItem("agreementFlag")) {
                setAgreementFlag(true);
            }
        }
        return () => {
            ignore = true;
        };
    }, []);

    const detectSize = () => {
        detectHW({
            winWidth: window.innerWidth,
            winHeight: window.innerHeight
        });
    };

    useEffect(() => {
        window.addEventListener("resize", detectSize);

        return () => {
            window.removeEventListener("resize", detectSize);
        };
    }, [windowDimension]);

    const handleMouseEnterName = () => {
        setDropdownVisibleName(true);
        if (window.scrollY < 50) setHeadColor(true);
    };

    const handleMouseLeaveName = () => {
        setDropdownVisibleName(false);
        if (window.scrollY < 50) setHeadColor(false);
    };

    // --- Start of Dynamic Sizing Logic ---

    // Define 1080p (1920px width) as the reference for scaling.
    const refWidth = 1920;
    const scaleFactor = windowDimension.winWidth / refWidth;

    // --- BASE DIMENSIONS at 1920px (Originals increased by 50%) ---
    const basePopupWidth = 1050; // 700 * 1.5
    const basePopupPadding = 30; // 20 * 1.5
    const baseBorderRadius = 18; // 12 * 1.5

    const baseGenieLogoWidth = 52.5; // 35 * 1.5
    const baseGenieLogoHeight = 75; // 50 * 1.5

    const baseLifeAtFordLogoWidth = 292.5; // 195 * 1.5
    const baseLifeAtFordLogoHeight = 67.5; // 45 * 1.5

    const baseTitleMargin = 30; // 20 * 1.5
    const baseTitleSize = 30; // 20 * 1.5
    const baseTitleTopMargin = -12; // -8 * 1.5

    const baseAgreementTextSize = 30; // 20 * 1.5

    const baseButtonFontSize = 24; // e.g., 16px * 1.5
    const baseButtonPaddingV = 15; // e.g., 10px * 1.5
    const baseButtonPaddingH = 30; // e.g., 20px * 1.5

    // Dynamically calculate styles for the popup container
    const dynamicPopupStyle: React.CSSProperties = {
        // Ensure the width doesn't exceed the viewport width with a 20px margin
        width: `${Math.min(basePopupWidth * scaleFactor, windowDimension.winWidth - 20)}px`,
        border: "1px",
        padding: `${basePopupPadding * scaleFactor}px`,
        borderRadius: `${baseBorderRadius * scaleFactor}px`,
        backgroundImage: "linear-gradient(to right, #eff2f9, #d1e1f8)",
        textAlign: "center",
        boxShadow: "1px 1px 10px 0px #2047ef",
        display: "flex",
        justifyContent: "center",
        fontFamily: "ArialNova",
        // Auto margins for centering
        marginLeft: "auto",
        marginRight: "auto",
        // Add some vertical margin for small screens
        marginTop: windowDimension.winHeight <= 340 ? "10px" : "auto",
        marginBottom: windowDimension.winHeight <= 340 ? "10px" : "auto"
    };

    // Dynamically calculate styles for the images and text inside the popup
    const dynamicGenieLogoStyle = {
        width: `${baseGenieLogoWidth * scaleFactor}px`,
        height: `${baseGenieLogoHeight * scaleFactor}px`
    };

    const dynamicLifeAtFordLogoStyle = {
        width: `${baseLifeAtFordLogoWidth * scaleFactor}px`,
        height: `${baseLifeAtFordLogoHeight * scaleFactor}px`
    };

    const dynamicGenieTitleStyle: React.CSSProperties = {
        fontWeight: "bold",
        color: "#2047ef",
        fontFamily: "ArialNova",
        marginTop: `${baseTitleTopMargin * scaleFactor}px`,
        marginLeft: `${baseTitleMargin * scaleFactor}px`,
        fontSize: `${baseTitleSize * scaleFactor}px`
    };

    const dynamicAgreementTextStyle: React.CSSProperties = {
        textAlign: "left",
        fontWeight: "bold",
        fontSize: `${baseAgreementTextSize * scaleFactor}px`
    };

    const dynamicButtonStyle: React.CSSProperties = {
        fontSize: `${baseButtonFontSize * scaleFactor}px`,
        padding: `${baseButtonPaddingV * scaleFactor}px ${baseButtonPaddingH * scaleFactor}px`,
        height: "auto",
        lineHeight: "normal"
    };
    // --- End of Dynamic Sizing Logic ---

    return (
        <div className="App" style={{ backgroundImage: "linear-gradient(to right, #eff2f9, #d1e1f8)", height: "100%" }}>
            {/* Idle Prompt Popup */}
            <Popup
                open={isIdle}
                closeOnDocumentClick={false}
                closeOnEscape={false}
                contentStyle={{
                    width: "400px",
                    padding: "20px",
                    borderRadius: "12px",
                    textAlign: "center",
                    boxShadow: "0 5px 15px rgba(0,0,0,0.3)"
                }}
            >
                <div>
                    <h2>Session Timeout</h2>
                    <p>You've been idle for a while. For your security, you will be logged out in 3 minutes.</p>
                    <Stack horizontal tokens={{ childrenGap: 20 }} horizontalAlign="center">
                        <ActionButton onClick={handleRefresh} className="animatedButton">
                            <b>Stay Logged In</b>
                        </ActionButton>
                        <ActionButton onClick={handleManualLogout} className="animatedButton-secondary">
                            <b>Logout Now</b>
                        </ActionButton>
                    </Stack>
                </div>
            </Popup>

            {!isSignedIn && (
                <header style={headerStyleNotSignedIn}>
                    <img src={fordLogo} alt="Ford Icon" />
                    <ActionButton
                        onClick={() => {
                            msalInstance.login();
                        }}
                        title="Click on here to Sign-In"
                        className="animatedButton"
                    >
                        <b>Log In</b>
                    </ActionButton>
                    <div style={{ fontFamily: "ArialNova" }}>You should be redirected to login in a few seconds. If not, click on "Log In" button.</div>
                </header>
            )}
            {isSignedIn && !sessionStorage.getItem("agreementFlag") && (
                <Popup open={isOpen} onClose={() => setIsOpen(false)} closeOnDocumentClick={false} closeOnEscape={false} contentStyle={dynamicPopupStyle}>
                    <div>
                        <Stack
                            horizontal
                            verticalAlign="center"
                            style={{
                                width: "100%"
                            }}
                        >
                            <Stack horizontal>
                                <div>
                                    <img src={genieLogo} alt="Genie Logo" style={dynamicGenieLogoStyle} />
                                </div>
                            </Stack>
                            <Stack
                                horizontal
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    flexWrap: "wrap",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    marginLeft: "auto",
                                    marginRight: "auto"
                                }}
                            >
                                <div>
                                    <img src={logo} alt="Life@Ford Logo" aria-label="Link to Life@Ford" style={dynamicLifeAtFordLogoStyle} />
                                </div>
                                <div style={dynamicGenieTitleStyle}>|| Compensation Planning Genie</div>
                            </Stack>
                        </Stack>
                        <p style={dynamicAgreementTextStyle}>
                            USAGE AGREEMENT.
                            <br />
                            <br />
                            Avoid submitting Ford{" "}
                            <a href="https://azureford.sharepoint.com/sites/SIPP/SitePages/ConfidentialClassification.aspx" target="_blank">
                                Confidential
                            </a>{" "}
                            or{" "}
                            <a href="https://azureford.sharepoint.com/sites/SIPP/SitePages/SecretClassification.aspx?web=1" target="_blank">
                                secret information
                            </a>{" "}
                            in the chat box (e.g. employee names, salary information, other Personally Identifiable Information (PII)).
                        </p>
                        <ActionButton
                            onClick={() => {
                                setIsOpen(false);
                                sessionStorage.setItem("agreementFlag", "1");
                                setAgreementFlag(true);
                            }}
                            title="Click on here to continue!"
                            className="animatedButton"
                            style={dynamicButtonStyle}
                        >
                            <b>I Agree And Continue</b>
                        </ActionButton>
                    </div>
                </Popup>
            )}
            {agreementFlag && isSignedIn && (
                <div>
                    {isDropdownVisibleName && <div className="overlay"></div>}
                    <header
                        style={{
                            position: "fixed",
                            display: "flex",
                            justifyContent: "space-between",
                            backgroundImage: headColor ? "linear-gradient(white, white, white, white, white, white, transparent)" : "none",
                            width: "100%",
                            height: "70px",
                            top: "0px",
                            zIndex: "9999"
                        }}
                    >
                        <div style={{ position: "fixed", left: "0px" }}>
                            <Layout />
                        </div>
                        {windowDimension.winWidth <= 660 && (
                            <div onMouseEnter={handleMouseEnterName} onMouseLeave={handleMouseLeaveName} style={{ cursor: "pointer" }}>
                                <div style={{ position: "fixed", right: "10px", marginLeft: "10px", marginTop: "12px" }}>
                                    <Person personQuery="me" className="personStyle" />
                                </div>
                                <div style={{ position: "fixed", right: "5px", marginTop: "52px" }}>{isDropdownVisibleName && <LogoutButton />}</div>
                            </div>
                        )}
                        {windowDimension.winWidth > 660 && (
                            <div
                                style={{ position: "fixed", right: "10px", marginTop: "20px" }}
                                onMouseEnter={handleMouseEnterName}
                                onMouseLeave={handleMouseLeaveName}
                            >
                                <Stack
                                    horizontal
                                    style={{
                                        fontFamily: "ArialNova",
                                        fontSize: "12px",
                                        backgroundColor: "white",
                                        padding: "5px",
                                        border: "1px solid #00095b",
                                        width: "101%",
                                        color: "#00095b",
                                        cursor: "pointer"
                                    }}
                                >
                                    <img src={lockIcon} />
                                    <div style={{ marginTop: "2px", textTransform: "uppercase" }}>Welcome, {msalInstance.getActiveAccount().name}</div>
                                </Stack>
                                {isDropdownVisibleName && <LogoutButton />}
                            </div>
                        )}
                    </header>
                </div>
            )}
            <div>
                {agreementFlag && isSignedIn && (
                    <BrowserRouter>
                        <Routes>
                            <Route index element={<Chat />} />
                            <Route path="/qa" element={<OneShot />} />
                            <Route path="*" element={<NoPage />} />
                        </Routes>
                    </BrowserRouter>
                )}
            </div>
        </div>
    );
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

const LogoutButton = () => {
    const [isDropdownVisible, setDropdownVisible] = useState(false);

    const handleMouseEnter = () => {
        setDropdownVisible(true);
    };

    const handleMouseLeave = () => {
        setDropdownVisible(false);
    };
    return (
        <div className="dropdown-menu">
            <ul className="listBox">
                <li className="list" onClick={handleLogout} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                    Log Out &nbsp; &nbsp; &nbsp;{" "}
                    <span style={{ float: "right", marginTop: "2px" }}>
                        {!isDropdownVisible && <img src={rightArrow} />}
                        {isDropdownVisible && <img src={rightArrowBlue} />}
                    </span>
                </li>
            </ul>
        </div>
    );
};
